// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer, action } from 'mobx-react';
import { Row, Col } from 'reactstrap';
import Analyse from '../../../Model/Analyse';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import OverviewHeader from '../../../Components/Layout/OverviewHeader/index';
import AnalyseForm from './AnalyseForm/index';

type Props = {
  router: any,
  params: any,
};

@observer
export default class AnalysisViewScreen extends React.Component<Props, void> {
  @observable analyse: Analyse = new Analyse();
  @observable loading: boolean = false;

  componentDidMount() {
    const { params: { id } } = this.props;
    if (id !== 'new') {
      this.load(id);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const { params: { id } } = this.props;
    if (id !== nextProps.params.id) {
      this.load(nextProps.params.id);
    }
  }

  async load(id: string) {
    this.loading = true;
    try {
      const analyse = await Analyse.get(id);
      this.analyse = analyse;
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }

  render() {
    const { analyse, loading } = this;
    const { params: { id } } = this.props;

    return (
      <Row>
        <Col>
          <OverviewHeader
            header={'new' === id ? 'Neue Analyse' : loading ? '' : analyse.name || '<ohne Name>'}
            print
          />
          <Row>
            <Col>
              <AnalyseForm analyse={analyse} />
              <LoadingOverlay show={loading} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/index.js